// Google tags helper — supports both GA4 (Analytics) and Google Ads
// GA4 ID     -> REACT_APP_GA_MEASUREMENT_ID (e.g. G-XXXXXXXXXX)
// Ads ID     -> REACT_APP_GOOGLE_ADS_ID     (e.g. AW-XXXXXXXXXX)
// Both are optional. Safe no-op if missing.

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;
let initialized = false;

export const initAnalytics = () => {
  if (initialized || typeof window === "undefined") return;
  const anyId = GA_ID || ADS_ID;
  if (!anyId) return;
  initialized = true;

  // Load a single gtag.js library (Google supports multiple configs on one loader)
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${anyId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());

  // Configure each product independently
  if (GA_ID) gtag("config", GA_ID, { send_page_view: false });
  if (ADS_ID) gtag("config", ADS_ID);
};

export const trackPageView = (path) => {
  if (typeof window === "undefined" || !window.gtag) return;
  if (!GA_ID) return;
  window.gtag("event", "page_view", {
    send_to: GA_ID,
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};

export const trackEvent = (name, params = {}) => {
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", name, params);
};

// Google Ads conversion helper — call after user completes a valuable action.
// Usage: trackAdsConversion('CONVERSION_LABEL', { value: 1.0, currency: 'USD' })
export const trackAdsConversion = (label, params = {}) => {
  if (typeof window === "undefined" || !window.gtag || !ADS_ID) return;
  window.gtag("event", "conversion", {
    send_to: `${ADS_ID}/${label}`,
    ...params,
  });
};
